var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "admin"
  }, [_c('div', {
    staticClass: "flex justify-between items-center pb-6 shadow-border-b mdmax:shadow-none mdmax:flex-col"
  }, [_c('div', {
    staticClass: "flex-1 mdmax:flex-auto mdmax:w-full mdmax:mb-2"
  }, [_c('LinkButton', {
    attrs: {
      "buttonText": _vm.$t('admin.list.addUser'),
      "url": "/admin/create",
      "linkType": "internal",
      "size": _vm.isMobile ? 'full' : 'regular'
    }
  })], 1), _c('div', {
    staticClass: "flex-1 flex gap-6 justify-end mdmax:flex-auto mdmax:w-full mdmax:justify-start"
  })]), _c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function fn(_ref) {
        var entry = _ref.entry,
            column = _ref.column;
        return [column.field === 'action' ? _c('LinkButton', {
          attrs: {
            "buttonText": _vm.$t('admin.list.moreDetail'),
            "url": "/admin/detail/".concat(entry.id),
            "linkType": "internal",
            "type": "secondary",
            "size": "small"
          }
        }) : column.field === 'created_at' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm._f("formatDate")(entry[column.field])) + " ")]) : column.field === 'id' ? _c('span', {
          staticClass: "block break-all"
        }, [_vm._v(" " + _vm._s(entry[column.field]) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  }), !_vm.isMobile ? _c('div', {
    staticClass: "text-neutral-500 font-medium mt-2 text-sm"
  }, [_vm._v(_vm._s(_vm.$t('ongkir.show')) + " " + _vm._s(_vm.start) + " - " + _vm._s(_vm.end) + " " + _vm._s(_vm.$t('ongkir.from')) + " " + _vm._s(_vm.totalRecords))]) : _vm._e(), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }